import { render, staticRenderFns } from "./EditableTitle.vue?vue&type=template&id=4b93ccf2"
import script from "./EditableTitle.vue?vue&type=script&lang=ts"
export * from "./EditableTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports